export default __webpack_public_path__ + "static/media/Foto galerija 2.c529e7a0.jpg";